/**
 * 稿件类型：0是图文，1是视频
 */
export enum ResourceTypeEnum {
  Article = 0,
  Video = 1,
  Picture = 2,
  Feed = 3,
  Comment = 4
}

export enum ContentTypeEnum {
  Plain = 0,
  RichText = 1,
  Markdown = 2,
  LimitMarkdown = 3
}

export enum NotifyTypeEnum {
  SYSTEM = 0,
  LIKE = 1,
  COMMENT = 2,
  FOLLOW = 3,
  MENTION = 4
}

export const defaultGrayImage =
  'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='

export const defaultUploadingImage =
  'https://resource.mfuns.net/imgs/uploading.png'
